import { merge } from "lodash";
import { generateEndpoints, prefix } from "../helpers";

const namespace = "account";

const nameSpace = merge({}, generateEndpoints(namespace), {
  get: {
    init: (contextApplicationId) => {
      const hasId = typeof contextApplicationId === "string" && contextApplicationId.length > 0;
      const query = hasId
        ? `?context-application-id=${encodeURIComponent(contextApplicationId)}`
        : "";
      return [`${prefix}/profile/${namespace}/init${query}`];
    },
  },
});

export default nameSpace;
